import {useState } from 'react'
import {useAuthContext} from '../../../hooks/useAuthContext.js'


const ResetPassword = () => {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState(null)
    const [data, setData] = useState('')
    const [loading, setLoading] = useState(false);
    const {dispatch} = useAuthContext()

    const handleSubmit = async ( event) => {
        event.preventDefault()
        setLoading(true)


        const response = await fetch('http://localhost:5000/api/user/resetPassword', {
            method: 'POST',
            headers:{'Content-Type': 'application/json'},
            body: JSON.stringify({ email, password, data, error})
        })
        const userData = await response.json()
        console.log(userData)
        
        
        if(userData.error){
            setError(userData.error)
        }else{
            setData(userData.data)
            console.log('here')
            dispatch({type: 'LOGIN', payload:userData})  
        }


        setLoading(false)
        setEmail('')
        setPassword('')
} 

    return (
    
        
        <div className = "login-continer">
            <div className = "login-box" >
                
                <form onSubmit = {handleSubmit}>
                    
                    <div class = "textbox"> 
                        <label>Email:</label>
                        <input
                            type = "email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                    </div>
                    <div class = "textbox">
                        <label>Password:</label>
                        <input
                            type = "password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />
                    </div>
                    <button type="submit" className = "btn">Reset Password</button>
                    
                    {data && <div className = "create">{data}</div>}
                    {error && <div className = "error">{error}</div>}
                </form>
            
            </div>

        </div>
 
    )

};

export default ResetPassword;